var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceMonthlySpendReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 510 510",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m355.312 256.722h-38.921c-4.688 0-8.503 3.814-8.503 8.502v205.228c0 4.688 3.815 8.527 8.503 8.527h38.921c4.688 0 8.502-3.839 8.502-8.527v-205.228c0-4.688-3.814-8.502-8.502-8.502z",
    fill: "#6cf5c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m355.312 256.722h-17.03c4.688 0 8.503 3.814 8.503 8.502v205.228c0 4.688-3.815 8.527-8.503 8.527h17.03c4.688 0 8.502-3.839 8.502-8.527v-205.228c0-4.688-3.814-8.502-8.502-8.502z",
    fill: "#00e499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.439 315.44h-38.921c-4.688 0-8.503 3.815-8.503 8.502v146.51c0 4.688 3.815 8.527 8.503 8.527h38.921c4.687 0 8.502-3.839 8.502-8.527v-146.51c0-4.687-3.815-8.502-8.502-8.502z",
    fill: "#ffe177"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.439 315.44h-17.03c4.688 0 8.528 3.815 8.528 8.502v146.51c0 4.688-3.84 8.527-8.528 8.527h17.03c4.687 0 8.502-3.839 8.502-8.527v-146.51c0-4.687-3.815-8.502-8.502-8.502z",
    fill: "#ffd064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m420.264 203.912h38.921c4.688 0 8.503 3.815 8.503 8.503v258.037c0 4.688-3.815 8.527-8.503 8.527h-38.921c-4.688 0-8.527-3.839-8.527-8.527v-258.037c0-4.688 3.839-8.503 8.527-8.503z",
    fill: "#8ac9fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m442.156 203.912h17.029c4.688 0 8.503 3.815 8.503 8.503v258.037c0 4.688-3.815 8.527-8.503 8.527h-17.029c4.687 0 8.502-3.839 8.502-8.527v-258.037c0-4.688-3.815-8.503-8.502-8.503z",
    fill: "#60b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.669 371.665h38.897c4.687 0 8.527 3.815 8.527 8.503v90.284c0 4.688-3.84 8.527-8.527 8.527h-38.897c-4.687 0-8.527-3.839-8.527-8.527v-90.284c0-4.688 3.84-8.503 8.527-8.503z",
    fill: "#fe646f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.536 371.665h17.03c4.687 0 8.527 3.815 8.527 8.503v90.284c0 4.688-3.84 8.527-8.527 8.527h-17.03c4.688 0 8.527-3.839 8.527-8.527v-90.284c0-4.688-3.839-8.503-8.527-8.503z",
    fill: "#fd4755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.386 151.477c-20.744 33.536-52.161 63.98-92.03 86.22-59.242 33.062-124.044 40.667-176.404 25.582 39.993.349 80.286-8.752 123.72-32.987 39.395-21.966 85.298-65.426 108.461-103.125l-20.346-13.639c-.823-.548-1.247-1.471-1.097-2.468.125-.998.773-1.771 1.745-2.07l69.989-22.639c.773-.25 1.521-.15 2.194.299s1.072 1.097 1.147 1.895l6.208 73.753c.075.998-.399 1.92-1.271 2.419-.848.523-1.87.474-2.718-.075z",
    fill: "#6cf5c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.386 151.477c-20.744 33.536-52.161 63.98-92.03 86.22-59.242 33.062-124.044 40.667-176.404 25.582.598.025 1.196.025 1.795.025h.872c49.194 9.45 113.747-3.441 160.348-29.446 46.576-25.981 73.13-55.503 93.875-89.038zm4.364-62.01 5.784 68.842 9.45 6.333c.848.549 1.87.598 2.718.075.872-.499 1.346-1.421 1.271-2.419l-6.208-73.753c-.075-.798-.474-1.446-1.147-1.895s-1.421-.549-2.194-.299z",
    fill: "#00e499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.317 473.12h405.195c4.688 0 8.503 3.815 8.503 8.502v4.114c0 4.688-3.815 8.503-8.503 8.503h-405.195c-4.687 0-8.502-3.815-8.502-8.503v-4.114c0-4.687 3.815-8.502 8.502-8.502z",
    fill: "#a79ba7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m495.015 483.667v2.069c0 4.688-3.815 8.503-8.503 8.503h-405.195c-4.687 0-8.502-3.815-8.502-8.503v-2.069z",
    fill: "#837683"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m122.797 15.761c59.525 0 107.788 48.263 107.788 107.812 0 59.525-48.263 107.788-107.788 107.788-59.549 0-107.812-48.263-107.812-107.788 0-59.549 48.263-107.812 107.812-107.812z",
    fill: "#8ac9fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.797 15.761c59.525 0 107.788 48.263 107.788 107.812v.047l-107.788-.047z",
    fill: "#6cf5c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.585 123.62c-.017 39.571-21.363 74.16-53.164 92.893l-54.624-92.94z",
    fill: "#ffe177"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceMonthlySpendReports);
export default __webpack_public_path__ + "static/media/invoice-monthly-spend-reports.c8429bc42734e58a9629af63726df84d.svg";
export { ForwardRef as ReactComponent };